import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import useFilterRows from "helpers/customHooks/useFilterRows";
import PageHeader from "components/PageHeader/PageHeader";
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
import {
    deactivateUserAction,
    activateUserAction,
    loadUsersAction,
    loadSitesAction,
    setPaginationAction,
    resendRegistrationEmailAction,
    resendRegistrationEmailToAllAction,
    downloadUsersAction,
    revokeUserAccessAction
} from "store/actions/Actions";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefAllUsers from "table-defs/TableDefAllUsers";
import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";
import { connect, useSelector, useDispatch } from "react-redux";
import { setSelectedRows, toggleDropdowns, exportAsCSV } from "helpers/utils";

const Users = props => {
    const { loadSitesAction, setPaginationAction, downloadUsersAction, loadUsersAction, SitesReducer, UsersReducer, deactivateUserAction, revokeUserAccessAction, activateUserAction, resendRegistrationEmailAction, resendRegistrationEmailToAllAction } = props;

    const dispatch = useDispatch();
    const DatatableReducer = useSelector((state) => state.DatatableReducer);

    const [state, setState] = useState({
        selectedRows: null,
        selected_sites: [],
    });

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!UsersReducer.users && SitesReducer.sites) {
            loadUsersAction({ inactive: true });
        }
    }, [UsersReducer.users, SitesReducer.sites, loadUsersAction]);

    // ##############################################

    const noFilters = {
        text: "",
        role: "",
        sites: "",
        status: "",
        selected_sites: []
    };

    const [filters, setFilters] = useState(
        (DatatableReducer.datatable && DatatableReducer.datatable.users && DatatableReducer.datatable.users.filters)
        ? DatatableReducer.datatable.users.filters
        : noFilters);


    const onChangeRowSelect = ({ selectedRows }) => {
        if (selectedRows !== state.selectedRows) {
            setState(s => ({ ...s, selectedRows }));
        }
    };

    const [selectedUsersIds, setSelectedUsersIds] = useState(
        (DatatableReducer.datatable && DatatableReducer.datatable.users && DatatableReducer.datatable.users.selectedIds)
            ? DatatableReducer.datatable.users.selectedIds
            : []);

    useEffect(() => {
        dispatch({
            type: 'SET_DATATABLE',
            payload: {
                datatable: {
                    users: {
                        selectedIds: selectedUsersIds,
                        filters,
                        selectedRows: state.selectedRows,
                        selected_sites: state.selected_sites,
                        rowsPerPage: (DatatableReducer.datatable && DatatableReducer.datatable.users && DatatableReducer.datatable.users.rowsPerPage)
                        ? DatatableReducer.datatable.users.rowsPerPage
                        : 10,
                        currentPage: (DatatableReducer.datatable && DatatableReducer.datatable.users && DatatableReducer.datatable.users.currentPage)
                        ? DatatableReducer.datatable.users.currentPage
                        : 0
                    },
                },
            },
        });
    }, [selectedUsersIds, filters, state]);

    const setFilter = filterName => e => {
        setFilters({
            ...filters,
            [filterName]:
                e.target.type === "checkbox"
                    ? e.target.checked
                    : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
        });
        setPaginationAction({ dataType: 'users', currentPage: 0 });
    };

    const filteredRows = useFilterRows(filters, UsersReducer.users);

    // ##############################################

    const openAddNewUser = () => props.history.push("/maintain/users/add");

    const siteDropdownRef = React.createRef();
    const roleDropdownRef = React.createRef();
    const statusDropdownRef = React.createRef();
    const chooseActionDropdownRef = React.createRef();

    const selectedIds = selectedUsersIds.map(item => item.id);

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const renderConfirmModal = () => {
        return ReactDOM.createPortal(
            <ConfirmationModal
                data={showConfirmModal}
                setShowModal={setShowConfirmModal}
            />,
            document.getElementById('modal-root'),
        );
    };

    const hadnleDownloadCSV = () => {
        downloadUsersAction();
    };

    const labels = () => (
        {
          name: {
            label: 'NAME',
          },
          email: {
            label: 'EMAIL',
          },
          status: {
            label: 'STATUS',
          },
          role_str: {
            label: 'ROLE',
          },
          last_modified: {
            label: 'MODIFIED',
          },
          created_at: {
            label: 'CREATED',
          }
        }
    );

    return (
        <AppLayoutWrapFull
            onClick={toggleDropdowns([
                roleDropdownRef,
                siteDropdownRef,
                statusDropdownRef,
                chooseActionDropdownRef
            ])}
        >
            <div id="modal-root"></div>
            <PageHeader showStats={true}>
                <PageHeaderActions
                    primaryButtonText="ADD USER"
                    primaryButtonHandler={openAddNewUser}
                    secondaryButtonText="BULK UPLOAD"
                    terianryButtonText="DOWNLOAD CSV"
                    terianryButtonHandler={() => hadnleDownloadCSV()}
                    terianryButtonIcon="fal fa-download"
                    secondaryButtonHandler={() =>
                        props.history.push('/maintain/users/add_bulk')
                    }
                    searchHandler={e => {
                        setFilters({ ...filters, text: e.target.value || "" })
                        setPaginationAction({ dataType: 'users', currentPage: 0 });
                    }}
                    searchValue={filters.text}
                    // siteDropdownRef={siteDropdownRef}
                    statusDropdownRef={statusDropdownRef}
                    chooseActionDropdownRef={chooseActionDropdownRef}
                    chooseAction={[
                        {
                            actionName: "Activate Selected",
                            actionHandler: () => {
                                
                                const idCount = selectedIds.length;

                                if (idCount > 0) {
                                    setShowConfirmModal({
                                        title: 'Acivate selected users',
                                        question: idCount === 1 ? 
                                            `Are you sure you want to activate the selected user?` : 
                                            `Are you sure you want to activate ${idCount} selected users?`,
                                        confirmAction: () => {
                                            activateUserAction({ items: selectedIds });
                                        },
                                    });
                                } else {
                                    setShowConfirmModal({
                                        type: 'simple',
                                        title: 'Nothing selected',
                                        question: `Please select one or more users.`,
                                    });
                                }
                            }
                        },
                        {
                            actionName: "Deactivate Selected",
                            actionHandler: () => {
                                
                                const idCount = selectedIds.length;

                                if (idCount > 0) {
                                    setShowConfirmModal({
                                        title: 'Deacivate selected users',
                                        question: idCount === 1 ? 
                                            `Are you sure you want to deactivate the selected user?` : 
                                            `Are you sure you want to deactivate ${idCount} selected users?`,
                                        confirmAction: () => {
                                            deactivateUserAction({ items: selectedIds });
                                        },
                                    });
                                } else {
                                    setShowConfirmModal({
                                        type: 'simple',
                                        title: 'Nothing selected',
                                        question: `Please select one or more users.`,
                                    });
                                }
                            }
                        },
                        {
                            actionName: "Resend emails to awaiting users",
                            actionHandler: () => resendRegistrationEmailToAllAction({ })
                        },
                        {
                            actionName: "Export Selected",
                            actionHandler: () => {
                                const data = UsersReducer.users.filter((item) => selectedUsersIds.map(i => i.id).includes(item.id));
                                const updatedData = data.map((item) => ({
                                    ...item,
                                    created_at: item.created_at.substring(0,10),
                                    last_modified: item.last_modified.substring(0,10)
                                }));
                                exportAsCSV(updatedData, labels, 'users.csv');
                            }
                        },
                    ]}
                    status={{
                        onChange: setFilter("status"),
                        options: [
                            "All",
                            "Awaiting Registration",
                            "Inactive",
                            "Active"
                        ]
                    }}
                    resetFilters={() => {setFilters(noFilters); setPaginationAction({ dataType: 'users', currentPage: 0 })}}
                    filters={filters}
                />
            </PageHeader>
            <Container wide fluid>
                {UsersReducer.users &&
                <FullDataTable
                    onRowClick={function(e) {
                        if (
                            e.currentTarget.classList.contains("col-actions") ||
                            e.currentTarget.classList.contains(
                                "col-row-selector"
                            )
                        )
                            return;
                        props.history.push(`/maintain/users/edit?id=${this.props.rowData.id}`);
                    }}
                    rowsData={filteredRows}
                    definitions={TableDefAllUsers}
                    dataType="users"
                    onChangeRowSelect={({ selectedRows }) => {                         
                        onChangeRowSelect({ selectedRows });
                    }}
                    setSelectedRows={setSelectedRows(["id"], setSelectedUsersIds)}

                    // onChangeRowSelect={({ selectedRows }) =>
                    //   this.onChangeRowSelect({ selectedRows })
                    // }
                    customTableProps={{
                        selectedRows: state.selectedRows ? state.selectedRows : selectedUsersIds,
                        onNameClick: ({ rowData }) => {
                            props.history.push(`/maintain/users/edit?id=${rowData.id}`);
                        },
                        edit: (rowData) => {
                            props.history.push(`/maintain/users/edit?id=${rowData.id}`);
                        },
                        activate: ({ id, registered }) => {
                            activateUserAction({ items: [id] })
                        },
                        deactivate: ({ id, registered }) => {
                            deactivateUserAction({ items: [id] })
                        },
                        resendRegistrationEmail:(rowData) => {
                            resendRegistrationEmailAction({ id : rowData.id});
                        },
                        revokeUserAccess: ({ id, name }) => {
                            setShowConfirmModal({
                                title: 'Revoke user access',
                                question: `You're about to revoke access for "${name}". Are you sure?`,
                                confirmAction: () => {
                                    revokeUserAccessAction({ id } )
                                },
                            });

                        }
                    }}
                />
                }
                {showConfirmModal && renderConfirmModal()}
            </Container>
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    UsersReducer: state.UsersReducer,
    SitesReducer: state.SitesReducer
});

const mapDispatchToProps = {
    deactivateUserAction,
    revokeUserAccessAction,
    downloadUsersAction,
    activateUserAction,
    loadUsersAction,
    setPaginationAction,
    loadSitesAction,
    resendRegistrationEmailAction,
    resendRegistrationEmailToAllAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Users);
